export interface DocumentVersionInfo {
    createdOn: string;
    effectiveDate: string;
    changeReason?: string;
    comments: string;
    isDeleted: boolean;
    createdBy: {
        id: string;
        firstName: string;
        lastName: string;
    };
}

export interface DocumentItem {
    id: string;
    name: string;
    comments: string;
    isPrivate: boolean;
    version: {
        createdOn: string;
        effectiveDate: string;
        modifiedList: string[];
        changeReason: {
            id: string;
            text: string;
        };
        comments: string;
        isDeleted: boolean;
        createdBy: {
            id: string;
            firstName: string;
            lastName: string;
        };
    };
    fileSize: number;
    contentType: string;
    isFolder: boolean;
    createdBy: {
        id: string;
        firstName: string;
        lastName: string;
    };
    inFolder: {
        id: string;
    };
    workLocations: Array<{
        id: string;
        name: string;
        region: {
            id: string;
            name: string;
        };
    }>;
    roles: Array<{
        id: string;
        name: string;
    }>;
    status: {
        id: string;
        name: string;
    };
}

export interface DocumentUpdateRequest {
    id: string;
    name?: string;
    comments?: string;
    isPrivate?: boolean;
    workLocations?: string[];
    roles?: string[];
    inFolder?: string;
    status?: string;
}

export interface DocumentCreateRequest {
    comments?: string;
    isPrivate?: boolean;
    workLocations?: string[];
    roles?: string[];
    inFolder?: string;
    status?: string;
}

export interface FolderCreateRequest {
    name: string;
    comments?: string;
    isPrivate?: boolean;
    workLocations?: string[];
    roles?: string[];
    inFolder?: string;
    status?: string;
}

export interface FileUploadRequest extends DocumentCreateRequest {
    file?: File;
}

export interface DocumentStatus {
    id: string;
    name: string;
}
